document.addEventListener('DOMContentLoaded', () => {
  const directions = document.querySelector('.directions');

  if (!directions) {
    return;
  }

  const COLLAPSE_DURATION = 300;
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const collapseTimers = new WeakMap();

  const shouldAnimate = () => (
    !reducedMotionQuery.matches && document.body.dataset.accessibility !== 'true'
  );

  const setExpanded = (toggle, expanded, { animate = true } = {}) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));

    if (!panel) {
      return;
    }

    const pendingTimer = collapseTimers.get(panel);

    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      collapseTimers.delete(panel);
    }

    toggle.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));

    if (expanded) {
      panel.hidden = false;

      if (!animate || !shouldAnimate()) {
        panel.classList.remove('is-collapsed');
        return;
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            panel.classList.remove('is-collapsed');
          }
        });
      });

      return;
    }

    panel.classList.add('is-collapsed');

    if (!animate || !shouldAnimate()) {
      panel.hidden = true;
      return;
    }

    const timer = window.setTimeout(() => {
      if (toggle.getAttribute('aria-expanded') === 'false') {
        panel.hidden = true;
      }

      collapseTimers.delete(panel);
    }, COLLAPSE_DURATION);

    collapseTimers.set(panel, timer);
  };

  const groupToggles = directions.querySelectorAll('.directions__group-toggle');

  groupToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

      groupToggles.forEach((otherToggle) => {
        setExpanded(otherToggle, otherToggle === toggle && willOpen);
      });
    });
  });
});
